import { translate as __ } from '../../common/I18n';

export const EMPTY_RESOURCE_TYPE = {
  name: '(Miscellaneous)',
  translation: __('(Miscellaneous)'),
  granular: false,
};

export const SEARCH_ID = 'filters_resource_type';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/FiltersForm/FiltersFormConstants.js